import React from 'react';
import { TweenMax } from 'gsap';

import imagesLoaded from 'imagesloaded';

import '../css/project.scss';

class PrjTopCmp extends React.Component {
    constructor(props){
        super(props);
        
        this.state = {
            isLoaded: false
        }

        // container type change
        this.container ='';
    }

    componentDidMount(){

        let showSpeed = 500;
        TweenMax.from(this.view, showSpeed/1000, 
            {
                opacity: 0,
                scale: 1.1,
                display: 'block'
            }
        );    
        
        // view page scroll top
        window.scrollTo({'top':0});


        // imagesLoaded안에서 this가 바뀌므로 this를 _this에 저장해서 사용
        let _this = this;

        // imagesLoaded / Detect when images have been loaded.
        imagesLoaded('img', function(){
            _this.setState({
                isLoaded: !_this.state.isLoaded
            });
        });


        // mount 후 담기
        this.container = document.getElementById('container');
        this.container.classList.add('type_view');
            
    }

    componentWillUnmount(){
        this.container.classList.remove('type_view');
    }

    render(){

        return (

            <React.Fragment>
                {/* loading */}
                {this.state.isLoaded ? 
                    ''
                :
                    <div className="loading_box">
                        <span>Loading ...</span>
                    </div>
                }
                
                <div className="item_view inner_left" ref={view => this.view = view}>
                    <div className="inner">

                        <div className="section_copy">
                            <p className="cate">{this.props.type}</p>
                            <p className="desc">
                                {this.props.desc}
                            </p>
                        </div>

                    </div>
                </div>

            </React.Fragment>
        )
    }
}

export default PrjTopCmp;